import { Box, Pagination, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useMemo, useState } from 'react';
import { useShipViewData } from '../../../store';
import useShipViewScenarioDeltas from '../../../hooks/useShipViewScenarioDeltas';
import TbnAlert from './TbnAlert';
import ShipCard from '../components/ship/ShipCard';
import CardContainer from '../components/shared/CardContainer';
import CardHeader from '../components/shared/CardHeader';
import GroupEditModal from '../modals/VoyageGroupEditModal';
import useScenarioMode from '../../../../../shared/hooks/useScenarioMode';

const ShipViewList = ({
  handleHistoryClick,
  onAddShip,
  setSnackbarOpen,
  setSnackbarMessage,
  setSnackbarSeverity,
  onScenarioDeltaChange,
}) => {
  const [editGroup, setEditGroup] = useState(null);
  const { isScenarioViewOnly } = useScenarioMode();
  const {
    shipViewGroups,
    shipViewGroupsBase,
    shipViewCurrentPage,
    shipViewTotalPages,
    fetchShipViewPage,
  } = useShipViewData();

  // Build lookup of base (non-scenario) groups by key for value-comparison highlighting
  const baseGroupsByKey = useMemo(() => {
    const map = new Map();
    for (const g of shipViewGroupsBase ?? []) {
      if (g.key) map.set(g.key, g);
    }
    return map;
  }, [shipViewGroupsBase]);
  const scenarioDeltas = useShipViewScenarioDeltas();

  if (!shipViewGroups || shipViewGroups.length === 0) {
    return <Typography>No voyages available</Typography>;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <TbnAlert
        severity='warning'
        onAddShip={onAddShip}
        message={(count) => (
          <>
            {count} {count === 1 ? 'voyage could' : 'voyages could'} not be
            aggregated because IMO is not set. You need to map{' '}
            {count === 1 ? 'this voyage' : 'these voyages'} to make{' '}
            {count === 1 ? 'it' : 'them'} visible in the Ship View.
          </>
        )}
      />
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {shipViewGroups.map((shipGroup) => (
          <Grid xs={12} key={shipGroup.key}>
            <ShipCard
              shipGroup={shipGroup}
              baseShipGroup={baseGroupsByKey.get(shipGroup.key) ?? null}
              CardHeader={CardHeader}
              CardContainer={CardContainer}
              handleHistoryClick={handleHistoryClick}
              onEditGroup={setEditGroup}
              scenarioDeltas={scenarioDeltas}
            />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Pagination
          count={shipViewTotalPages}
          page={shipViewCurrentPage}
          onChange={(event, value) => fetchShipViewPage(value)}
        />
      </Box>
      <GroupEditModal
        open={!!editGroup}
        shipGroup={editGroup}
        readOnly={isScenarioViewOnly}
        onClose={() => {
          setEditGroup(null);
          fetchShipViewPage(shipViewCurrentPage);
          scenarioDeltas.refresh();
          onScenarioDeltaChange?.();
        }}
        setSnackbarOpen={setSnackbarOpen}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
      />
    </Box>
  );
};

export default ShipViewList;
